import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from 'src/app/core/config/application-config.service';
import { QueryModel } from '../common/query.model';
import { ResponseCodeEnum } from '../Entity/response.enum';
import { AlertService } from './alert.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  accountStatus = [
    { value: 1, name: 'Active' },
    { value: 2, name: 'Password Need To Reset' },
    { value: 3, name: 'Account Restricted' },
    { value: 4, name: 'Account Temporary Blocked' },
    { value: 5, name: 'Account Inactive' },
    { value: 6, name: 'Password Expired' },
    { value: 7, name: 'Basic Customer' },
    { value: 8, name: 'Unauthorized Customer' },
    { value: 9, name: 'Customer Pin Not Set' },
    { value: 10, name: 'Unauthorized Customer Force Password Change' },
    { value: 11, name: 'Device Binding Needed' },
    { value: 12, name: 'Customer Pin Reset' },
  ];

  eKYCStatus = [
    { value: 1, name: 'Basic' },
    { value: 2, name: 'Intermediate' },
    { value: 3, name: 'Graduate' },
  ];

  checkerMakerStatus = [
    { value: 0, name: 'Reinitiate' },
    { value: 1, name: 'Initiate' },
    { value: 2, name: 'Intermediate' },
    { value: 3, name: 'Graduate' },
  ];

  currentStatus = [
    { name: 'Approve', value: 1 },
    { name: 'Reject', value: 0 },
  ]
  occupations = [];
  salarySources = [];
  genders = [];
  approximateSalaries = [];

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected applicationConfigService: ApplicationConfigService
  ) { }

  toQueryString(obj: any) {
    let parts = [];
    for (const property in obj) {
      const value = obj[property];
      if (value != null && value !== undefined) {
        parts.push(encodeURIComponent(property) + '=' + encodeURIComponent(value));
      }
    }

    return parts.join('&');
  }

  toFormData(obj: any) {
    let formData = new FormData();
    for (const property in obj) {
      const value = obj[property];
      if (value != null && value !== undefined) {
        formData.append(property, value);
      }
    }

    return formData;
  }

  personalInfo(): Observable<any> {
    const api = this.applicationConfigService.getEndpointFor('meta/personal-information');
    return this.http.get<any>(`${api}`, { observe: 'response' });
  }
  
  getDocuments(merchant_identity: any): Observable<any> {
    const api = this.applicationConfigService.getEndpointFor(`merchant/documents/${merchant_identity}`);
    return this.http.get<any>(`${api}`, { observe: 'response' });
  }


  aggregatorList(): Observable<any> {
    const api = this.applicationConfigService.getEndpointFor('payment/bill/aggregators');
    return this.http.get<any>(`${api}`, { observe: 'response' });
  }

  fieldTypeList(): Observable<any> {
    const api = this.applicationConfigService.getEndpointFor('payment/bill/field-type');
    return this.http.get<any>(`${api}`, { observe: 'response' });
  }

  getUTCDate(date: any): Date {
    const _date = new Date(date);
    return new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate()));
  };

  getPaginationQuery(event: LazyLoadEvent | any, query: any = null): any {
    if (!query) {
      query = new QueryModel(0, 10);
    }
    
    query.pageSize = event?.rows || 10;
    query.pageNumber = event?.first! > 0 ? (event?.first! / query.pageSize) : 0;
    query.sortBy = event?.sortField || 'id';
    query.sortOrder = (event?.sortOrder && event?.sortOrder < 0) ? 'ASC' : 'DESC';
    query.size = event?.rows || 10;
    return query;
  }

  getOccupation(val: any) {
    const arr = this.occupations as any[];
    return arr.find((el: any) => el.value === val)?.key;
  }
  getApproximateSalary(value: any) {
    const arr = this.approximateSalaries as any[];
    return arr.find((el: any) => el.value === value)?.key;
  }
  getSalarySource(value: any) {
    const arr = this.salarySources as any[];
    return arr.find((el: any) => el.value === value)?.key;
  }
  getGender(value: any) {
    const arr = this.genders as any[];
    return arr.find((el: any) => el.value === value)?.key || '';
  }

  getAccountStatus(value: any) {
    return this.accountStatus.find(el => el.value === value)?.name;
  }
  getCheckerMakerStatus(value: any) {
    return this.checkerMakerStatus.find(el => el.value === value)?.name;
  }

  accountStatusList(): Observable<any> {
    const api = this.applicationConfigService.getEndpointFor('customer/settings/customer/status');
    return this.http.get<any>(`${api}`, { observe: 'response' });
  }

  formatImageUrl(path: any) {
    if(path.startsWith('http')) {
      return path;
    }
    else {
      return environment.baseUrl + path;
    }
  }

  getReadableText(text: any) {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}
